module.exports = __webpack_public_path__ + "static/media/people.3f21ad7e.png";